import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { HelpService } from 'src/app/services/help.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MenuService } from 'src/app/services/menu.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { CheckboxComponent } from '../../admin/checkbox/checkbox.component';
import { messages } from 'src/app/popUpMessages/messages';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { DeleteiconComponent } from '../../deleteIconNormalGrid/deleteicon.component';
import { ConfigurationKmatComponent } from '../configuration-kmat/configuration-kmat.component';
import { ProjectService } from 'src/app/services/project.service';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { EditDeleteComponent } from 'src/app/grid/button-edit/edit-delete/edit-delete.component';
import { LockIconComponent } from 'src/app/lock-icon/lock-icon.component';
import moment from 'moment';
import { QuicklinksComponent } from '../quicklinks/quicklinks.component';
import { MultiSelectEditorComponent } from '../Multiselectdropdown/multi-select-editor/multi-select-editor.component';
import { CategorizationService } from 'src/app/services/categorization.service';
import { CellRendererComponent } from 'ag-grid-community/dist/lib/components/framework/componentTypes';
import { ICellRendererParams } from 'ag-grid-community/dist/lib/rendering/cellRenderers/iCellRenderer';
//import { ConfigurationMEKSimulationComponent } from '../configuration-Products/configuration-Products.component';
import { ComponentEditProductComponent } from '../edit-product/edit-product.component';
import { truncate } from 'fs';
import { CommentboxComponent } from 'src/app/commentbox/commentbox.component';
import { EnumModuleId } from 'src/app/enum/EnumModuleId';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfigurationComponent implements OnInit {
  @ViewChild('commentBox') commentBox: CommentboxComponent;

  public hasCommentUnsavedChanges: boolean = false;

  public rowData: any = [];
  public defaultColDef: any;
  public columnDefs: any = [];
  public gridApi: any;
  public gridColumnApi: any;
  public domLayout: any;
  public rowHeight: any;
  public headerHeight: any;
  public alertErrorBox = [];
  public errorMessage = []
  public loggedInUser: any;
  public getResponse: any;
  public frameworkComponents: any;
  public idGenerated: number = 1;
  public hasUnsavedChanges: boolean = false;
  public submitted: boolean = false;
  public isEditable: boolean = true;

  public sizeToFitRefresh: number = 0;
  public showGrid = false;

  public businessAreaId: number;
  public businessLineId: number;
  public userInOrg: any;
  public allUserList: any;
  public modifiedConfigurationRows = []
  projectSubmitterId: any;

  submitResponse: any;
  receivedData: any;
  totalDataCount: any;
  projectId: any;
  moduleId: number = 4;
  objData: any;
  userDetails: [];
  configurationData: any;
  configurationFromLocal: any;
  allConfigurations: any;
  lockVisible: boolean;
  isAdmin: boolean;
  status: any = [];
  options: any;
  public Standdata: any = [];
  menuData: any[] = [];
  openPopup: any;
  public agGridContext = {
    onProductDataUpdate: (updatedProductData: any[], configId: any, rowIndex: number) => this.onProductDataUpdate(updatedProductData, configId, rowIndex)
  };
  TCProductData: any[];
  isAccessVisible: boolean;
  HasMinorAccess: boolean;
  isProductTreeVisible:boolean;
  tcConfigurationMenuRoleId: number;
  tcConfigurationMenuIsDisplay: boolean;
  constructor(
    private toast: ToasterService,
    private sharedService: SharedServiceService,
    private configurationService: ConfigurationService,
    private projectService: ProjectService,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private router: Router,
    private menuService: MenuService,
    private userService: UserInfoService,
    private helpService: HelpService,
    private catService: CategorizationService,
  ) { }


  ngOnInit() {


    this.sharedService.getProjectIdAndTitle();

    this.projectId = this.localStorageService.get("projectId");
   
    this.objData = {
      projectId: this.projectId,
      moduleId: Number(EnumModuleId.ConfigurationOverview),
      configurationId: 0
    }
    if (this.projectId != null) {
      //  console.log(4);
      this.projectService.getTCData(this.projectId).subscribe((data: any) => {
        if (data.StatusCode == 200) {
          this.businessAreaId = data.Data.BusinessAreaId;
          this.businessLineId = data.Data.BusinessLineId;
          this.sharedService.loggedInUser.subscribe((user: any) => {
            if (user) {
              this.showGrid = true
              this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d) => {
                this.allUserList = d;
                this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
                if (this.userInOrg != undefined) {
                  // console.log("user", this.userInOrg, data.Data);
                  this.projectSubmitterId = this.userInOrg.UserId;

                  let userIsFinancialController = data.Data.FinancialControllerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsFinancialControllerProxy = data.Data.FinancialControllerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  // let userIsSubmitter = data.Data.SubmitterId.split(',').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManager = data.Data.ProductManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManagerProxy = data.Data.ProductManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManager = data.Data.ProjectManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManagerProxy = data.Data.ProjectManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManager = data.Data.ServiceManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManagerProxy = data.Data.ServiceManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineer = data.Data.ProcurementEngineerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineerproxy = data.Data.ProcurementEngineerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitect = data.Data.SystemArchitectIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitectProxy = data.Data.SystemArchitectProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsWatchList = data.Data.WatchListIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);

                  if (userIsFinancialController || userIsFinancialControllerProxy || this.userInOrg.TargetRoleId == 1) {
                    this.lockVisible = true;
                  }

                  if (this.userInOrg.TargetRoleId == 1) {
                    this.isAdmin = true;
                  }

                  if (this.userInOrg.TargetRoleId == 1 ) {
                    this.isEditable = true;
                  }
                  else if (this.userInOrg.TargetRoleId == 3 || this.userInOrg.TargetRoleId == 2) {
                    if (data.Data.SubmitterId == this.userInOrg.UserId || userIsFinancialController || userIsFinancialControllerProxy
                      || userIsProductManager || userIsProductManagerProxy || userIsProjectManager || userIsProjectManagerProxy
                      ||userIsProcurementEngineer || userIsProcurementEngineerproxy
                      || userIsSystemArchitect || userIsSystemArchitectProxy 
                    ) {
                      this.isEditable = true;
                    }
                    else {
                      this.isEditable = false;
                    }

                    // if (data.Data.SubmitterId == this.userInOrg.UserId || this.HasMinorAccess == false) {
                    //   this.isEditable = true;
                    // }
                    // else {
                    //   this.isEditable = false;
                    // }
                  }

                  if (data.Data.SubmitterId == this.userInOrg.UserId || userIsFinancialController || userIsFinancialControllerProxy ||
                    userIsProjectManager || userIsProjectManagerProxy

                  ) {

                    this.isAccessVisible = true;
                  }
                  if (data.Data.SubmitterId == this.userInOrg.UserId|| userIsFinancialController || userIsFinancialControllerProxy ||
                    userIsProductManager || userIsProductManagerProxy

                  ) {

                    this.isProductTreeVisible = true;
                  }
                }
                this.loadGrid();
                this.loadData();
              })
            }
          })
        }
      });
    } else {
      this.businessAreaId = this.businessLineId = 0;
    }


  }
  onProductDataUpdate = (updatedProductData: any[], configId: any, rowIndex: number) => {
    // console.log(updatedProductData, configId, rowIndex);
    //This will update the SelectedProductDa in rowdata for that specific configurationId
    // console.log(this.rowData);
    this.rowData[rowIndex].Product = updatedProductData;
    // console.log(this.rowData);
    // this.rowData.find(x => x.Id == configId && x.RowIndex == rowIndex)["Product"] = updatedProductData;
    // this.TCProductData = updatedProductData;
    this.hasUnsavedChanges = true;
    if (configId != 0) {
      let isPushed = false;
      if (this.modifiedConfigurationRows.length == 0) {
        this.modifiedConfigurationRows.push(this.rowData[rowIndex]);
        isPushed = true;
      }
      else {
        this.modifiedConfigurationRows.forEach(row => {
          if (configId == row.Id) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedConfigurationRows.push(this.rowData[rowIndex]);
      }
    }
    // this.modifiedConfigurationRows.push(this.rowData.find(x => x.Id == configId));
    this.gridApi?.refreshCells({ force: true });
    // Any additional logic you want, e.g. refresh grid, mark as dirty, etc.
  };



  loadData() {
    this.showGrid = false;
    this.configurationFromLocal = this.localStorageService.get("configuration");
    this.configurationService.getConfigurationData(this.projectId, this.userInOrg.UserId).subscribe(d => {
      this.showGrid = true;
      let errorMsgeFromBack = d.Data.Message;
      if (d.StatusCode == 200) {
        this.configurationData = d.Data;
        this.configurationData.forEach(data => {
          data["IsAdmin"] = this.isAdmin
          data["IsEditable"] = this.isEditable
          data["LockVisible"] = this.lockVisible
          data["AccessVisible"] = this.isAccessVisible
          data["ProductTreeVisible"] =this.isProductTreeVisible
        })

        this.rowData = this.configurationData;
        // console.log(this.businessAreaId, this.businessLineId)
        this.rowData.forEach(data => {
          data["businessAreaId"] = this.businessAreaId
          data["businessLineId"] = this.businessLineId
          this.configurationService.GetLockStatus(
            this.projectId,
            data.Id,
            this.userInOrg.UserId,
            false).subscribe(res => {
              if (res && res.Data && res.Data.length > 0) {
                data.IsLockedForEdit = res.Data[0].IsLock;
                data.LockedBy = res.Data[0].UserName;
                this.gridApi.refreshCells({
                  force: true
                });
              }
            });
        });
        if (this.configurationFromLocal != null) {
          if (this.configurationFromLocal.configurationId == 0) {
            this.hasUnsavedChanges = true;
            this.addNewRow();
          }
          else {
            let row = this.configurationData.find(x => x.Id == this.configurationFromLocal.configurationId);
            if (row) {
              this.hasUnsavedChanges = true;
              this.modifiedConfigurationRows.push(row);
            }
          }
        }

        const shouldAutoSubmit = this.localStorageService.get("autoSubmitTcConfiguration");
        const shouldTriggerAutoSubmit = shouldAutoSubmit === true || shouldAutoSubmit === "true";
        if (shouldTriggerAutoSubmit) {
          this.localStorageService.remove("autoSubmitTcConfiguration");
          setTimeout(() => {
            if (this.hasUnsavedChanges) {
              const result = this.submit();
              if (result instanceof Promise) {
                result.then((success) => {
                  this.submitted = false;
                  this.modifiedConfigurationRows = [];
                  this.configurationFromLocal = null;
                  this.localStorageService.remove("configuration");
                  this.loadData();
                });
              } else {
                // submit() returned synchronously (validation failed / nothing to save)
                // loadData() is already done, grid is visible — nothing more needed
              }
            }
          }, 0);
        }
      } else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer);
      }
    });
  }

  loadGrid() {
    this.columnDefs = [
      {
        headerName: "ID",
        field: "Id",
        tooltipField: "id",
        headerTooltip: "ID",
        width: 80,
      },
      {
        headerName: "Name",
        field: "Name",
        tooltipField: "Name",
        headerTooltip: "Name",
        cellEditor: 'agTextCellEditor',
        singleClickEdit: true,
        width: 480,
        editable: (params) => {
          if (params.data.IsLock)
            return false
          else
            return ((!params.data.IsLock && this.isEditable))
        },
        cellStyle: (params) => (params.data.Name == "Add Name" || params.data.Name == "") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
      },
      {
        headerName: "EQ",
        field: "eq",
        tooltipField: "eq",
        headerTooltip: "EQ",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "CS",
        field: "cs",
        tooltipField: "cs",
        headerTooltip: "CS",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "SCM",
        field: "scm",
        tooltipField: "scm",
        headerTooltip: "SCM",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "LC",
        field: "lc",
        tooltipField: "lc",
        headerTooltip: "LC",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "Inv",
        field: "inv",
        tooltipField: "inv",
        headerTooltip: "Inv",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "TDC",
        field: "tdc",
        tooltipField: "tdc",
        headerTooltip: "TDC",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "PLC",
        field: "plc",
        tooltipField: "plc",
        headerTooltip: "PLC",
        width: 60,
        cellRendererFramework: QuicklinksComponent,
      },
      {
        headerName: "Stands",
        field: 'Stands',
        headerTooltip: "Stands",
        cellRenderer: dropdownTextRenderer,
        cellEditorFramework: MultiSelectEditorComponent,
        width: 150,
        singleClickEdit: true,
        editable: (params) => {
          if (params.data.IsLock)
            return false
          else
            return ((!params.data.IsLock && this.isEditable))
        },
      },
      {
        headerName: "Product",
        field: "Product",
        headerTooltip: "Product",
        width: 100,
        cellRendererParams: (params) => {
          // console.log("cellRendererParams", params);
          return {
            SelectedProductData: {
              // productArray:    this.TCProductData
              getProductData: () => this.getProductData(params.data.Id, params.rowIndex),
              getRowIndex: () => params.rowIndex
            }
          }
        },
        cellRendererFramework: ComponentEditProductComponent,
      },

      {
        headerName: "Created by",
        field: "CreatedUserName",
        tooltipField: "CreatedBy",
        headerTooltip: "Created by",
        width: 150,
      },
      {
        headerName: "Created on",
        field: "CreatedOn",
        tooltipField: "CreatedOn",
        valueFormatter: (params) => params.value == null ? null : moment(params.value).format('DD/MM/YYYY'),
        headerTooltip: "Created on",
        width: 160,
      },
      {
        headerName: "Modified by",
        field: "ModifiedUserName",
        tooltipField: "ModifiedBy",
        headerTooltip: "Modified by",
        width: 160,
      },
      {
        headerName: "Modified on",
        field: "ModifiedOn",
        tooltipField: "ModifiedOn",
        valueFormatter: (params) => params.value == null ? null : moment(params.value).format('DD/MM/YYYY'),
        headerTooltip: "Modified on",
        width: 150,
      },
      {
        headerName: "Milestone",
        field: "MilestoneName",
        tooltipField: "milestone",
        headerTooltip: "Milestone",
        width: 120,
      },
      {
        filter: false,
        headerName: "Lock",
        field: "IsLock",
        tooltipField: "lock",
        headerTooltip: "Lock",
        cellRendererFramework: LockIconComponent,
        width: 100,
      },
      {
        filter: false,
        //width: 350,
        headerName: 'Action',
        headerTooltip: "Action",
        cellRendererFramework: EditDeleteComponent,
        cellRendererParams: (params) => 
        {
          return {
            isEditDisabled: params.data.IsLockedForEdit,
            editToolTip: params.data.IsLockedForEdit ? 
            'Cofiguration has been locked by ' + params.data.LockedBy : 'Edit'
          };
        },
        width: 240,
      },
    ];
    this.showGrid = true;
    this.defaultColDef = {
      filter: true,
      sortable: true,
      singleClickEdit: true,
      editable: false
    };
    this.domLayout = 'autoHeight';

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi
    this.sizeToFitRefresh = 1;
  }

  onGridSizeChanged(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  onDisplayedColumnsChanged(event) {
    if (this.sizeToFitRefresh != 0) {
      this.gridApi.sizeColumnsToFit();
    }
  }



  onCellValueChanged(params) {
    // console.log("onCellValueChanged", params);
    this.hasUnsavedChanges = true;
    if (params.data.Id != 0) {
      let isPushed = false;
      if (this.modifiedConfigurationRows.length == 0) {
        this.modifiedConfigurationRows.push(params.data);
        isPushed = true;
      }
      else {
        this.modifiedConfigurationRows.forEach(row => {
          if (params.data.Id == row.Id) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedConfigurationRows.push(params.data);
      }
    }
    // console.log("modifiedConfigurationRows", this.modifiedConfigurationRows);
  }

  addNewRow() {
    this.hasUnsavedChanges = true;
    this.alertErrorBox = [];
    let errorMessage = messages.cellEmptyErrorMesssage;
    let error = [];

    this.rowData.push({
      Id: 0,
      Name: "Add Name",
      eq: null,
      cs: null,
      scm: null,
      lc: null,
      inv: null,
      tdc: null,
      plc: null,
      Product: [],
      CreatedUserName: this.userInOrg?.FullName,
      CreatedOn: new Date(),
      ModifiedUserName: null,
      ModifiedOn: null,
      MileStoneName: '',
      IsEditable: true,
      LockVisible: false,
      AccessVisible: false,
      businessAreaId: this.businessAreaId,
      businessLineId: this.businessLineId
    });
    this.idGenerated += 1;

  }
  getProductData(configId, rowIndex): any[] {
    if ((configId == 0) || (configId == undefined)) {
      return this.rowData[rowIndex].Product || [];
    }
    else {
      let productArray = this.rowData.find(x => x.Id == configId)?.Product || [];
      return productArray || [];
    }
  }
  addNewConfiguration() {
    this.alertErrorBox = [];
    let errorMessage = messages.cellEmptyErrorMesssage;
    let error = [];
    let lastRow = this.gridApi.getDisplayedRowAtIndex(this.gridApi.getDisplayedRowCount() - 1);

    if (lastRow != undefined) {
      let data = lastRow.data;

      if (data.Name == "" || data.Name == "Add Name") {
        error.push({ Name: errorMessage })
      }
      if (error.length != 0) {
        this.openAlertDialog(error);
        return false;
      }
    }

    let configuration = {
      configurationId: 0,
      selectedKmat: 0,
      addedVblo: null,
      removedVblo: null
    };
    this.localStorageService.set("configuration", configuration);
    this.localStorageService.set("ConfigId", 0);
    this.router.navigate(['/tc-configuration-vblo']);
    // let dialogRef = this.dialog.open(ConfigurationKmatComponent, {
    //   height: '60%',
    //   width: '40%',
    //   panelClass: 'kmat-dialog-container'
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result != "" && result != undefined) {
    //     let configuration = {
    //       configurationId: 0,
    //       selectedKmat: result.KMATId,
    //       addedVblo: null,
    //       removedVblo: null
    //     };
    //     this.localStorageService.set("configuration", configuration);
    //     this.router.navigate(['/tc-configuration-vblo']);
    //   }
    // });
  }
  // addNewProject() {
  //   this.alertErrorBox = [];
  //   let errorMessage = messages.cellEmptyErrorMesssage;
  //   let error = [];
  //   // let lastRow = this.gridApi.getDisplayedRowAtIndex(this.gridApi.getDisplayedRowCount() - 1);

  //   // if (lastRow != undefined) {
  //   //   let data = lastRow.data;

  //   //   if (data.Name == "" || data.Name == "Add Name") {
  //   //     error.push({ Name: errorMessage })
  //   //   }
  //   //   if (error.length != 0) {
  //   //     this.openAlertDialog(error);
  //   //     return false;
  //   //   }
  //   // }
  //   let dialogRef = this.dialog.open(ConfigurationMEKSimulationComponent, {
  //     height: '60%',
  //     width: '40%',
  //     panelClass: 'kmat-dialog-container'
  //   });

  //   // dialogRef.afterClosed().subscribe(result => {
  //   //   if (result != "" && result != undefined) {
  //   //     let configuration = {
  //   //       configurationId: 0,
  //   //       selectedKmat: result.KMATId,
  //   //       addedVblo: null,
  //   //       removedVblo: null
  //   //     };
  //   //     this.localStorageService.set("configuration", configuration);
  //   //     this.router.navigate(['/tc-configuration-vblo']);
  //   //   }
  //   // });
  // }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  canDeactivate() {
    return this.hasUnsavedChanges;
  }

  getUserInfo(){
    return this.userInOrg.UserId;
  }
  
  // Check if comment has unsaved changes
  canDeactivateComment(): boolean {
    return this.hasCommentUnsavedChanges;
  }

  // Handle comment unsaved changes event from child
  onCommentUnsavedChange(hasChanges: boolean) {
    this.hasCommentUnsavedChanges = hasChanges;
  }

  // Submit comment changes
  async submitComment(): Promise<boolean> {
    if (this.commentBox && this.hasCommentUnsavedChanges) {
      return await this.commentBox.saveCommentIfNeeded();
    }
    return true;
  }

  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.localStorageService.remove("configuration");
    this.router.navigate(["/tc-manageProject"]);
  }

  onClickBack() {
    this.menuService.onClickNextAndBack("back");
  }

  onClickNext() {
    this.localStorageService.remove("configuration");
    this.menuService.onClickNextAndBack("next");
  }

  submit(event?: any) {
    if (!this.hasUnsavedChanges && event == undefined) {
      return true
    }
    let errorMessage = messages.cellEmptyErrorMesssage;
    let error = [];
    let lastRow = this.gridApi.getDisplayedRowAtIndex(this.gridApi.getDisplayedRowCount() - 1);

    if (lastRow != undefined) {
      let data = lastRow.data;

      if (data.Name == "" || data.Name == "Add Name") {
        error.push({ Name: errorMessage })
      }
    }
    if (error.length != 0) {
      this.openAlertDialog(error);
      return false;
    }
    else {
      let response = null;
      this.showGrid = false;
      this.submitted = true;

      try {
        let gridData = this.modifiedConfigurationRows ? [...this.modifiedConfigurationRows] : [];
        let sendData = this.sendData(gridData);

        if (!sendData?.lsttcconfiguration || sendData.lsttcconfiguration.length == 0) {
          this.showGrid = true;
          this.submitted = false;
          this.hasUnsavedChanges = false;
          return true;
        }

        response = this.configurationService.saveConfiguration(sendData).toPromise().
          then((res) => {
            this.showGrid = true;
            this.submitResponse = res;
            let successCode = this.submitResponse.StatusCode;
            let errorCode = this.submitResponse.Data.ErrorCode;
            let errorMsgeFromBack = this.submitResponse.Data.Message;
            if (successCode == 200) {
              if (errorCode == 0) {

              if (event != undefined && event.route === '/tc-manageProject') {
                this.localStorageService.set("ConfigId", null);
                this.sharedService.changeConfigId(0);
              }

                this.hasUnsavedChanges = false;
                let dataSaveMessage = serverMessage.dataSaveMessage;
                this.toast.notify(dataSaveMessage, "success");


                if (event != undefined) {
                  this.localStorageService.remove("configuration");
                  this.hasUnsavedChanges = false;
                  this.router.navigate(['/tc-manageProject'])
                }
                return true;
              }
              else {
                //Show errorCode and errorMessage in the UI
                let errorContainer = [
                  { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
                  { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
                ]
                this.openAlertDialog(errorContainer)
                this.submitted = false;
                return false;
              }
            }
            else {
              let errorContainer = [
                { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
                { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
              ]
              this.openAlertDialog(errorContainer)
              this.submitted = false;
              return false;
            }
          },
            (error) => {
              this.showGrid = true;
              this.submitted = false;
              this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
              return false;
            })

        return response;
      }
      catch (error) {
        this.showGrid = true;
        this.submitted = false;
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
        return false;
      }
    }
  }

  sendData(gridData) {
    this.gridApi.forEachNode(node => {
      if (node.data.Id == 0 && node.data.Name != "Add Title") {
        this.hasUnsavedChanges = true;
        gridData.push(node.data);
      }
    })
    // console.log(gridData);
    let lstConfiguration = [];

    for (let i of gridData) {
      if (!i) {
        continue;
      }
      lstConfiguration.push({
        Id: i.Id,
        Name: i.Name,
        Product: i.Product,
        StandIds: i.Stands?.map(obj => obj.ID).join(', '),
        CreatedBy: this.userInOrg.UserId,
        CreatedOn: new Date(),
        ModifiedBy: null,
        ModifiedOn: null,
        KMATId: 0,
        AddVBLOMaterialIDs: [],
        RemoveVBLOMaterialIDs: [],
        PrimaryKMATId: 0,
        PrimaryKmatChanged: null
      })
    }
    // console.log(lstConfiguration);

    if (this.configurationFromLocal != null) {
      lstConfiguration.forEach(c => {
        if (c.Id == this.configurationFromLocal.configurationId) {
          c.KMATId = this.configurationFromLocal.selectedKmat;
          c.PrimaryKMATId = this.configurationFromLocal.primaryKmatId;
          c.PrimaryKmatChanged = this.configurationFromLocal.primaryKmatChanged;
          c.AddVBLOMaterialIDs = this.configurationFromLocal.addedVblo;
          c.RemoveVBLOMaterialIDs = this.configurationFromLocal.removedVblo;
        }
      })
    }

    // console.log(lstConfiguration);
    // if (lstConfiguration != null) {
    //   this.TCProductData = []; // Clear previous data if needed
    //   lstConfiguration.forEach(config => {
    //     if (config.Product && Array.isArray(config.Product)) {
    //       config.Product.forEach(prod => {
    //         this.TCProductData.push(prod);
    //       });
    //     }
    //   });
    // }

    let tcConfigurationData = {
      projectId: this.projectId,
      userId: this.userInOrg.UserId,
      lsttcconfiguration: lstConfiguration,
      // Product: this.TCProductData
    }
    // console.log(tcConfigurationData);
    return tcConfigurationData;
  }
}

function dropdownTextRenderer(params: ICellRendererParams) {

  const selectedIds = params.value;
  // const selectedTexts: any;
  // if(params.value!=undefined)
  // {
  const selectedTexts = selectedIds?.map(obj => obj.StandTitle).join(', ')

  return selectedTexts;
  // }
}
